'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _radio = require('../components/radio');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Claims() {
  return _react2.default.createElement(_radio.RadioYesNo, {
    name: 'claims',
    label: 'Have you been involved in any accident, claim or loss, irrespective of blame during the past three years?',
    helpText: 'Including loss by fire, theft or malicious acts.'
  });
}
exports.default = Claims;